// External libraries
import React from "react";

// Project components
import Button from "../../../../../Components/Button";
import TableLite from "../../../../../Components/TableLite";

/**
 * Table component for displaying and managing employee groups
 * @param {Object} props - Component props
 * @param {Array} props.employeeGroups - Array of employee group objects to display
 * @param {Function} props.onEdit - Callback function when edit button is clicked
 * @param {Function} props.onDelete - Callback function when delete button is clicked
 * @param {Array} [props.employees=[]] - Array of employee objects for name lookup
 * @returns {JSX.Element|null} The employee groups table component or null if no groups
 */
const EmployeeGroupTable = ({ employeeGroups, onEdit, onDelete, employees = [] }) => {
	if (!employeeGroups || employeeGroups.length === 0) {
		return null;
	}

	/**
	 * Convert employee IDs to display names
	 * @param {Array} employeeIds - Array of employee IDs to convert
	 * @returns {string} Comma-separated employee names or IDs if names not found
	 */
	const getEmployeeNames = (employeeIds) => {
		if (!employeeIds || !Array.isArray(employeeIds)) return "";
		return employeeIds
			.map((id) => {
				const employee = employees.find((emp) => emp.id === id);
				return employee ? employee.name : `ID: ${id}`;
			})
			.join(", ");
	};

	const columns = [
		{ id: "name", label: "Name", getter: (row) => row.name },
		{ id: "employees", label: "Employees", getter: (row) => getEmployeeNames(row.employees) },
		{ id: "admins", label: "Admins", getter: (row) => getEmployeeNames(row.admins) },
		{
			id: "adminPermissions",
			label: "Admin Permissions",
			getter: (row) => (row.adminPermissions === true || row.adminPermissions === "true" ? "True" : "False"),
		},
		{
			id: "edit",
			label: "Edit",
			getter: (row, index) => (
				<Button color="blue" size="small" onClick={() => onEdit(row.id)}>
					Edit
				</Button>
			),
		},
		{
			id: "delete",
			label: "Delete",
			getter: (row, index) => (
				<Button color="red" size="small" onClick={() => onDelete(row.id)}>
					Delete
				</Button>
			),
		},
	];
	return <TableLite columns={columns} rows={employeeGroups} />;
};

export default EmployeeGroupTable;
